import { render, staticRenderFns } from "./checkingProjectArea.vue?vue&type=template&id=bda877c4&scoped=true"
import script from "./checkingProjectArea.vue?vue&type=script&lang=js"
export * from "./checkingProjectArea.vue?vue&type=script&lang=js"
import style0 from "./checkingProjectArea.vue?vue&type=style&index=0&id=bda877c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda877c4",
  null
  
)

export default component.exports